import { segmentClient } from '@/lib/analytics/segment';
import { useClerk } from '@clerk/nextjs';

export function CustomSignInButton() {
  const clerk = useClerk();

  const handleSignIn = () => {
    segmentClient.track('Button Pressed', {
      choiceValue: 'Sign In',
      eventCategory: 'game setup',
      eventSubCategory: 'landing-page',
      displayChoices: ['Create Character', "I'm feeling lucky", 'Sign In'],
    });

    clerk.openSignIn();
  };

  return (
    <button
      onClick={handleSignIn}
      className="px-6 py-2 text-white bg-white/10 hover:bg-white/20 rounded-full font-semibold transition-all duration-200 border border-white/30 backdrop-blur-sm"
    >
      Sign In
    </button>
  );
}
